export default "https://cdn-static.gokick.com/assets/9d5d62c9c10b295872f7f6ffd14ff177054c61a9/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";